import { API } from "../../config/API/api.config";

import * as authUtil from "../../utils/auth.util";

import axios from "axios";

// Intercept expired/invalid JWT tokens and redirect to login
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const message = error?.response?.data?.message;
    const isJwtExpired =
      status === 400 &&
      typeof message === "string" &&
      message.toLowerCase().includes("jwt expired");
    const isUnauthorized = status === 401;

    if (isJwtExpired || isUnauthorized) {
      authUtil.logout();
      window.location.href = "/auth/login";
    }
    return Promise.reject(error);
  }
);

export interface ApiResponse<T = any> {
  data: {
    data: T;
    count?: number;
    success?: boolean;
    message?: string;
  };
  status: number;
}

const defaultHeaders = {
  isAuth: true,
  AdditionalParams: {},
  isJsonRequest: true,
  api_key: true,
};

export const ApiPostNoAuth = (type: any, userData: any) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        API.endpoint + type,
        userData,
        getHttpOptions({ ...defaultHeaders, isAuth: false })
      )
      .then((responseJson: any) => {
        resolve(responseJson);
      })
      .catch((error: any) => {
        if (
          error &&
          error.hasOwnProperty("response") &&
          error.response &&
          error.response.hasOwnProperty("data") &&
          error.response.data &&
          error.response.data.hasOwnProperty("error") &&
          error.response.data.error
        ) {
          reject(error.response.data.error);
        } else {
          reject(error);
        }
      });
  });
};

export const ApiGet = (type: any): Promise<ApiResponse> => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${API.endpoint}${type}`, getHttpOptions())
      .then((responseJson: any) => {
        resolve(responseJson);
      })
      .catch((error: any) => {
        if (
          error &&
          error.hasOwnProperty("response") &&
          error.response &&
          error.response.hasOwnProperty("data") &&
          error.response.data &&
          error.response.data.hasOwnProperty("error") &&
          error.response.data.error
        ) {
          reject(error.response.data.error);
        } else {
          reject(error);
        }
      });
  });
};

export const ApiPost = (
  type: any = "",
  userData: any = [],
  AdditionalHeader: any = []
) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${API.endpoint}${type}`, userData, {
        ...getHttpOptions(),
        ...AdditionalHeader,
      })
      .then((responseJson: any) => {
        resolve(responseJson);
      })
      .catch((error: any) => {
        if (
          error &&
          error.hasOwnProperty("response") &&
          error.response &&
          error.response.hasOwnProperty("data") &&
          error.response.data &&
          error.response.data.hasOwnProperty("error") &&
          error.response.data.error
        ) {
          reject(error.response.data.error);
        } else {
          reject(error);
        }
      });
  });
};

export const ApiPut = (type: any, userData: any) => {
  return new Promise((resolve, reject) => {
    axios
      .put(`${API.endpoint}${type}`, userData, getHttpOptions())
      .then((responseJson: any) => {
        resolve(responseJson);
      })
      .catch((error: any) => {
        if (
          error &&
          error.hasOwnProperty("response") &&
          error.response &&
          error.response.hasOwnProperty("data") &&
          error.response.data &&
          error.response.data.hasOwnProperty("error") &&
          error.response.data.error
        ) {
          reject(error.response.data.error);
        } else {
          reject(error);
        }
      });
  });
};

export const ApiDelete = (type: any = "", userData: any = []) => {
  return new Promise((resolve, reject) => {
    axios({
      url: `${API.endpoint}${type}`,
      method: "delete",
      headers: getHttpOptions().headers,
      data: userData,
    })
      .then((responseJson: any) => {
        resolve(responseJson);
      })
      .catch((error: any) => {
        if (
          error &&
          error.hasOwnProperty("response") &&
          error.response &&
          error.response.hasOwnProperty("data")
        ) {
          reject(error.response.data);
        } else {
          reject(error);
        }
      });
  });
};

const getHttpOptions = (options = defaultHeaders) => {
  let headers: any = {};
  if (options.hasOwnProperty("isAuth") && options.isAuth) {
    if (authUtil.getToken()) {
      headers["x-auth-token"] = authUtil.getToken();
    } else if (authUtil.getAdminToken()) {
      headers["x-auth-token"] = authUtil.getAdminToken();
    }
  }

  if (options.hasOwnProperty("api_key") && options.api_key) {
    const apiKey = process.env.REACT_APP_API_KEY;
    if (apiKey) {
      headers["api_key"] = apiKey;
    }
  }
  if (options.hasOwnProperty("isJsonRequest") && options.isJsonRequest) {
    headers["Content-Type"] = "application/json";
  }

  if (options.hasOwnProperty("AdditionalParams") && options.AdditionalParams) {
    headers = { ...headers, ...options.AdditionalParams };
  }

  return { headers };
};
